<template>
  <b-modal id="deleteMediaModal" centered modal-class="modal-doom-yoga">
    <div class="d-block mb-4">
      <input id="media_id" name="media_id" type="hidden" v-model="media_id" />
      <input id="client" name="client" type="hidden" v-model="client_name" />
      <p class="confirmMessageModalP message-modal-dy my-4">
        Are you sure you want to delete this {{ sub_media_type }}?
      </p>
    </div>
    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100">
        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="doomyoga-primary"
            class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-submit"
            v-if="!is_loading"
            @click="clickConfirmDelete"
          >
            Yes
          </b-button>
          <b-button
            type="button"
            disabled
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit w-100"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="doomyoga-danger-outline"
            class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-submit"
            @click="closeModalDelete"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
  <script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DeleteMedia",
  props: ["client_name", "media_id", "media_type", "sub_media_type"],
  data() {
    return {
      is_loading: false,
    };
  },

  mounted() {},

  methods: {
    clickConfirmDelete() {
      console.log("in confirm delete media ", this.client_name, this.media_id);
      // return;
      this.is_loading = true;

      axios
        .post(
          "/media/library/delete-media",
          { id: this.media_id },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            // timer: 5000,
          }).then((r) => {
            this.$bvModal.hide("deleteMediaModal");
            console.log(this.media_type, this.sub_media_type);
            if (
              this.media_type == "video_library" &&
              this.sub_media_type == "video"
            ) {
              this.$parent.getOpenCategoryVideosList();
            } else if (
              this.media_type == "meditation_library" &&
              this.sub_media_type == "video"
            ) {
              console.log(this.$parent);
              this.$parent.getOpenCategoryVideosList();
            } else if (
              this.media_type == "meditation_library" &&
              this.sub_media_type == "audio"
            ) {
              console.log(this.$parent);
              this.$parent.$parent.getOpenCategoryAudiosList();
              this.$parent.$parent.getMediaCategoryList();
              this.$parent.initComponent();
            } else if (this.media_type == "music_library") {
              console.log(this.$parent);
              this.$parent.$parent.getOpenCategoryMediaList();
              this.$parent.$parent.getMediaCategoryList();
              this.$parent.initComponent();
              this.$parent.initComponent();
            }
          });

          // console.log("test3")
        })
        .catch((error) => {
          // console.log(error.response.data.error);
          // console.log(error.request);
          // console.log(error.message);
          this.is_loading = false;

          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 5000,
          }).then((r) => {
            // console.log(r);
            // console.log(r.value);
          });
          // this.$parent.getUserList()
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteMediaModal");
    },
  },
};
</script>
  


// WEBPACK FOOTER //
// src/components/doom_yoga/media/DeleteMedia.vue